// PasswordResetService.js

/**
 * PasswordResetService.js
 *
 * Firebase Auth helpers for forgot-password and email-link reset completion.
 */

import { sendPasswordResetEmail } from 'firebase/auth';

import { auth, APP_BASE_URL } from 'firebaseConfig';

const PASSWORD_RESET_PATH = '/auth/reset-password';

/**
 * Sends a password reset email via Firebase Auth.
 *
 * @param {string} email - Account email address.
 * @returns {Promise<void>}
 */
export async function sendPasswordReset(email) {
  const normalizedEmail = String(email || '').trim().toLowerCase();

  if (!normalizedEmail) {
    throw new Error('Please enter your email address.');
  }

  const continueUrl = `${APP_BASE_URL}${PASSWORD_RESET_PATH}`;

  await sendPasswordResetEmail(auth, normalizedEmail, {
    url: continueUrl,
    handleCodeInApp: true,
  });
}

export const PASSWORD_RESET_CONTINUE_PATH = PASSWORD_RESET_PATH;
